import React from 'react';
import ControlsClose from './ControlsClose';
const ControlsCloseXS = ({ color, ...props }) => (React.createElement(ControlsClose, Object.assign({ color: color, size: 16 }, props)));
ControlsCloseXS.displayName = 'ControlsCloseXS'; // Fix for tsc
export default ControlsCloseXS;
//# sourceMappingURL=ControlsCloseXS.js.map